import { computed } from 'vue';
import { useStore } from 'vuex';

export function useDevToolsMenuItem() {
    const profileAppCodes = computed(() => store.getters['auth/profileAppCodes']);
    const store = useStore();

    const hasProfileAppAccess = computed(() => appCode => profileAppCodes.value?.includes(appCode));

    const devToolsMenuItems = computed(() => ({
        items: [
            {
                icon: 'shield',
                id: '__resident_auth_dev_tools',
                label: 'Resident auth dev tools',
                permissionChecker: hasProfileAppAccess.value('RAA'),
                children: [
                    {
                        label: 'Profiles',
                        id: 'raaTools.profiles.index',
                    },
                    {
                        label: 'Identities',
                        id: 'raaTools.identities.index',
                    },
                    {
                        label: 'Relationship types',
                        id: 'raaTools.relationshipTypes.index',
                    },
                    {
                        label: 'Applications',
                        id: 'raaTools.applications.index',
                    },
                    {
                        label: 'Shared data keys',
                        id: 'raaTools.sharedDataKeys.index',
                    },
                ],
            },
            {
                icon: 'cloud',
                id: '__resident_auth_local_data',
                label: 'Resident auth local data',
                permissionChecker: hasProfileAppAccess.value('RAA'),
                children: [
                    {
                        label: 'Persons',
                        id: 'raaTools.persons.index',
                    },
                    {
                        label: 'Parties',
                        id: 'raaTools.parties.index',
                    },
                    {
                        label: 'Memberships',
                        id: 'raaTools.memberships.index',
                    },
                ],
            },
            {
                icon: 'control-method',
                id: '__permissions_dev_tools',
                label: 'Permissions dev tools',
                permissionChecker: hasProfileAppAccess.value('PRMSN'),
                children: [
                    {
                        label: 'Identity permissions',
                        id: 'prmsnTools.identityPermissions.index',
                    },
                ],
            },
        ],
    }));

    return { devToolsMenuItems };
}
